import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  FilePlus2,
  Users,
  LayoutTemplate,
  Settings as SettingsIcon,
  LogOut,
  GraduationCap,
  PenTool,
  Type,
  Globe,
} from "lucide-react";
import { useAuth } from "../lib/auth";
import { Toaster } from "../components/ui/sonner";

const links = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, testId: "nav-dashboard" },
  { to: "/admin/new", label: "New Certificate", icon: FilePlus2, testId: "nav-new" },
  { to: "/admin/records", label: "Student Records", icon: Users, testId: "nav-records" },
  { to: "/admin/templates", label: "Templates", icon: LayoutTemplate, testId: "nav-templates" },
  { to: "/admin/designer", label: "Template Designer", icon: PenTool, testId: "nav-designer" },
  { to: "/admin/fonts", label: "Font Library", icon: Type, testId: "nav-fonts" },
  { to: "/admin/website", label: "Website", icon: Globe, testId: "nav-website" },
  { to: "/admin/settings", label: "Settings", icon: SettingsIcon, testId: "nav-settings" },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="flex min-h-screen bg-slate-50">
      {/* Sidebar */}
      <aside className="w-64 shrink-0 border-r border-slate-200 bg-white flex flex-col">
        <div className="px-6 py-6 border-b border-slate-100">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-blue-800 to-blue-600 grid place-items-center text-white shadow-md">
              <GraduationCap size={22} />
            </div>
            <div>
              <div className="font-display text-lg font-bold text-slate-900 leading-tight">
                Lovely Institute
              </div>
              <div className="text-xs text-slate-500">Certificate Studio</div>
            </div>
          </div>
        </div>
        <nav className="flex-1 px-3 py-4 space-y-1">
          {links.map(({ to, label, icon: Icon, testId }) => (
            <NavLink
              key={to}
              to={to}
              data-testid={testId}
              className={({ isActive }) =>
                `side-link transition-soft ${isActive ? "active" : ""}`
              }
              end={to === "/admin"}
            >
              <Icon size={18} />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="px-4 py-4 border-t border-slate-100">
          <div className="flex items-center justify-between px-2 py-2">
            <div className="min-w-0">
              <div className="text-xs text-slate-500">Signed in</div>
              <div className="text-sm font-semibold text-slate-900 truncate">
                {user?.username || "Admin"}
              </div>
            </div>
            <button
              data-testid="logout-btn"
              onClick={() => {
                logout();
                nav("/login");
              }}
              className="p-2 rounded-md text-slate-600 hover:bg-slate-100 hover:text-red-600 transition-soft"
              title="Log out"
            >
              <LogOut size={18} />
            </button>
          </div>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
      <Toaster position="top-right" richColors />
    </div>
  );
}
